import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog"

import Loading from "../../../common/Loading"

import { Button, DropDownField, TextAreaField, TextInputField } from "../../../helpers"

import { getStockWarehousesForCreateSellerDebitNote, insertSellerDebitNoteFromSmartStock } from "../../../services/api/stockAdjustment";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../../services/api/buyerReqItem";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { getDateTimeString, getFullName, validateInputs } from "../../../utils";

import { createSellerDebitNoteSchema, createSellerDebitNoteInitialValues } from "../../../validation/stockAdjustment";


const CreateSellerDebitNote = (props) => {

    const { setVisibleCreateSellerDebitNote, pmCompanyDetails } = props

    const [createSellerDebitNote, setCreateSellerDebitNote] = useState(createSellerDebitNoteInitialValues)
    const [sellerPIPunches, setSellerPIPunches] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [smartStockMoves, setSmartStockMoves] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [sellerPO, setSellerPO] = useState(null)
    const [materialDetails, setMaterialDetails] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState({})

    const usersData = useSelector(state => state.userDetails)

    const [formErrors, setFormErrors] = useState([])

    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        setCreateSellerDebitNote({...createSellerDebitNoteInitialValues, sellerPODocNo: createSellerDebitNote.sellerPODocNo})
        setSellerPIPunches([])
        setSmartStockMoves([])
        setSellerPOItems([])
        setSellerPO(null)
        setMaterialDetails([])
        setSellerCompanyDetails({})
    }, [createSellerDebitNote.sellerPODocNo])

    const handleOnHideCreateSellerDebitNote = () => {
        setCreateSellerDebitNote(createSellerDebitNoteInitialValues)
        setSellerPIPunches([])
        setSmartStockMoves([])
        setSellerPOItems([])
        setSellerPO(null)
        setMaterialDetails([])
        setSellerCompanyDetails({})
        setVisibleCreateSellerDebitNote(false)
    }

    const handleCreateSellerDebitNoteChange = (event) => {
        const updatedCreateSellerDebitNote = { ...createSellerDebitNote, [event.target.name]: event.target.value }
        setCreateSellerDebitNote({ ...updatedCreateSellerDebitNote })
    }

    const handleSellerPOSearchClick = async () => {

        if(!createSellerDebitNote.sellerPODocNo){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter seller PO Doc No!', life: 3000 }))
        }

        if(createSellerDebitNote.sellerPODocNo.toString().length !== 15){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter valid seller PO Doc No!', life: 3000 }))
        }

        if(createSellerDebitNote.sellerPODocNo.toString().slice(0,2) !== '15'){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter valid seller PO Doc No!', life: 3000 }))
        }

        setIsLoading(true)
        const sellerPIPunchesRes = await getStockWarehousesForCreateSellerDebitNote({ sellerPODocNo: createSellerDebitNote.sellerPODocNo })
        if (sellerPIPunchesRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: sellerPIPunchesRes.data.error, life: 3000 }))
        }

        if (sellerPIPunchesRes.data) {
            const buyerReqItemsIds = sellerPIPunchesRes.data.sellerPOItems.map(eachPOItem => eachPOItem.buyerReqItemId)
            const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({buyerReqItemsIds: buyerReqItemsIds})
            if (materialDetailsRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', detail: materialDetailsRes.data.error, life: 3000 }))
            }

            const updatedSellerPIPunchItems = sellerPIPunchesRes.data.sellerPIPunchItems.map(eachSellerPIPunchItem => {
                return {...eachSellerPIPunchItem, DNQty: null}
            })

            const updatedSellerPIPunches = sellerPIPunchesRes.data.sellerPIPunches.map(eachSellerPIPunch => {
                return {...eachSellerPIPunch,  piPunchDropdownText: `${eachSellerPIPunch.sellerPINumber} (${eachSellerPIPunch.sellerPIDate})`}
            })

            const KAMName = pmCompanyDetails.companyUsers.find(eachUser => eachUser.userId === sellerPIPunchesRes.data.sellerPO.createdBy)
            const updatedSellerPO = {...sellerPIPunchesRes.data.sellerPO, kamFullName: getFullName(KAMName.firstName, KAMName.lastName)}

            setSellerPIPunches(updatedSellerPIPunches)
            setSellerPIPunchItems(updatedSellerPIPunchItems)
            setSmartStockMoves(sellerPIPunchesRes.data.smartStockMoves)
            setSellerPO(updatedSellerPO)
            setSellerCompanyDetails(sellerPIPunchesRes.data.sellerCompanyDetails)
            setSellerPOItems(sellerPIPunchesRes.data.sellerPOItems)
            setMaterialDetails(materialDetailsRes.data)

            const updatedCreateSellerDebitNote = {...createSellerDebitNoteInitialValues, sellerPODocNo: createSellerDebitNote.sellerPODocNo}
            setCreateSellerDebitNote({ ...updatedCreateSellerDebitNote })
        }

        setIsLoading(false)
    }

    const handleSellerPIPunchItem = (event, piPunchItem, avlSmartStockQty) => {

        let inputQty = parseFloat(event.target.value)
        let invalidQtyText = ''
        if (inputQty > parseFloat(piPunchItem.qty) || inputQty > parseFloat(avlSmartStockQty)) {
            if (parseFloat(avlSmartStockQty) >= parseFloat(piPunchItem.qty)) {
                event.target.value = parseFloat(piPunchItem.qty)
                invalidQtyText = `Max PI Punch qty is ${piPunchItem.qty}!`
            } else {
                event.target.value = parseFloat(avlSmartStockQty)
                invalidQtyText = "Input quantity exceeds available smart stock qtuantity!"
            }
        }

        const updatedSellerPIPunchItems = sellerPIPunchItems.map(eachSellerPIPunchItem => {
            if(eachSellerPIPunchItem.sellerPIPunchItemId === piPunchItem.sellerPIPunchItemId){
                return {...eachSellerPIPunchItem, DNQty: event.target.value}
            }
            return eachSellerPIPunchItem
        })

        setSellerPIPunchItems(updatedSellerPIPunchItems)

        if (invalidQtyText) dispatch(raiseToast({ severity: 'warn', detail: invalidQtyText, life: 3000 }))
    }

    const handleSubmitClick = async () => {
        const validationRes = await validateInputs(createSellerDebitNoteSchema, createSellerDebitNote)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {
                setFormErrors({})

                const relatedSellerPIPunch = sellerPIPunches.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === createSellerDebitNote.sellerPIPunchId)
                const adjustmentNote = {
                    adjustmentTypeId: 10,
                    fileNo: relatedSellerPIPunch.fileNo, //parentFileNo
                    docNo: relatedSellerPIPunch.docNo, //parentDocNo
                    sellerPIPunchId: relatedSellerPIPunch.sellerPIPunchId,
                    companyId: sellerPO.companyId,
                    branchId: sellerPO.branchId,
                    remarks: createSellerDebitNote.remarks,
                    createdBy: usersData.userId,
                    statusId: 1
                }

                const filteredSellerPIPunchItems = sellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.DNQty)
                const adjustmentNoteItems = filteredSellerPIPunchItems.map(eachSellerPIPunchItem => {
                    const relatedSellerPOItem = sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === eachSellerPIPunchItem.sellerPOItemId)
                    return ({
                        sellerPIPunchItemId: eachSellerPIPunchItem.sellerPIPunchItemId,
                        sellerPOItemId: relatedSellerPOItem.sellerPOItemId,
                        materialId: relatedSellerPOItem.materialId,
                        adjustedQty: parseFloat(eachSellerPIPunchItem.DNQty),
                        adjustedPricePerUnit: relatedSellerPOItem.unitPrice,
                        createdBy: usersData.userId,
                    })
                })

                if (window.confirm("Are you sure you want to continue?")) {
                    setIsLoading(true)
                    const insertSellerDebitNoteRes = await insertSellerDebitNoteFromSmartStock({ adjustmentNote, adjustmentNoteItems, smartStockMoves, sellerPOItems })

                    if (insertSellerDebitNoteRes.failure) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: 'Seller Debit Note', detail: insertSellerDebitNoteRes.data.error, life: 3000 }))
                    }
                    else {
                        dispatch(raiseToast({ severity: 'success', detail: 'Successfully created Seller Debit Note!' }))

                        navigate(`/debitNote/${insertSellerDebitNoteRes.data.adjustmentNoteId}`)
                        setIsLoading(false)
                        handleOnHideCreateSellerDebitNote()
                    }
                }
            }
        }
    }

    let relatedSellerPIPunchItems = []
    if(createSellerDebitNote.sellerPIPunchId){
        relatedSellerPIPunchItems = sellerPIPunchItems.filter(eachSellerPIPunch => {
            const relatedSellerPOItem = sellerPOItems.find(eachPOItem => eachPOItem.sellerPOItemId === eachSellerPIPunch.sellerPOItemId)
            if(relatedSellerPOItem && createSellerDebitNote.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId){
                return true
            }
            return false
        })
    }

    return (
        <Dialog header="Create Seller Debit Note from Smart Stock" visible={props.visible} style={{ minHeight: "60%", width: '60vw' }} onHide={handleOnHideCreateSellerDebitNote}>
            <Loading visible={isLoading} />
            <div className="flex flex-row">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="sellerPODocNo" labelText="Seller PO Doc No" value={createSellerDebitNote.sellerPODocNo} onChange={handleCreateSellerDebitNoteChange} errorMessage={formErrors.sellerPODocNo} keyfilter={"pnum"} maxLength={15} required />
                </div>
                <div className="flex align-items-center mt-3">
                    <Button label='Search' className='h-2rem p-2' onClick={handleSellerPOSearchClick} text />
                </div>
            </div>
            {sellerPO &&
                <>
                    <div className="flex flex-row m-0 mt-2 mb-2">
                        <p className="flex align-items-center ml-2">Seller Company:<span className="text-black-alpha-90">{sellerCompanyDetails.companyName}</span></p>
                        <p className="flex align-items-center ml-3"><span>Created On: </span><span className="text-black-alpha-90">{getDateTimeString(sellerPO.createdAt)}</span></p>
                        <p className="flex align-items-center ml-3"><span>KAM Name: </span><span className="text-black-alpha-90">{sellerPO.kamFullName}</span></p>
                    </div>
                    <div className="flex flex-row">
                        <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                            <DropDownField name="sellerPIPunchId" labelText="PI Punches" options={sellerPIPunches} value={createSellerDebitNote.sellerPIPunchId} optionLabel="piPunchDropdownText" optionValue="sellerPIPunchId" onChange={handleCreateSellerDebitNoteChange} errorMessage={formErrors.sellerPIPunchId} required />
                        </div>

                        {/* <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                            <DropDownField name="warehouseId" labelText="Warehouse" options={companyWarehouses} value={createSellerDebitNote.warehouseId} optionLabel="warehouseName" optionValue="warehouseId" disabled errorMessage={formErrors.warehouseId} required />
                        </div> */}
                    </div>
                </>
            }
            {
                createSellerDebitNote.sellerPIPunchId &&
                <>
                    {
                        relatedSellerPIPunchItems.length ?
                            <>
                                {relatedSellerPIPunchItems.map(eachSellerPIPunchItem => {
                                    const relatedSellerPIPunch = sellerPIPunches.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === eachSellerPIPunchItem.sellerPIPunchId)
                                    const relatedSmartStockMoves = smartStockMoves.filter(eachSmartStockMove => eachSmartStockMove.materialId === eachSellerPIPunchItem.materialId)
                                    const relatedSellerPOItem = sellerPOItems.find(eachPOItem => eachPOItem.sellerPOItemId === eachSellerPIPunchItem.sellerPOItemId)

                                    let avlSmartStockQty = 0
                                    relatedSmartStockMoves.forEach(eachSmartStockMove => {
                                        avlSmartStockQty += parseFloat(eachSmartStockMove.moveQty)
                                    })

                                    const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerPIPunchItem.materialId)
                                    const materialText = `${relatedMaterialDetails.materialId} | ${relatedMaterialDetails.productName} | ${relatedMaterialDetails.productSpecification}`

                                    return (
                                        <>
                                            <div key={`sellerPIPunchItem-${eachSellerPIPunchItem.sellerPIPunchItemId}`} className="flex flex-row">
                                                <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                                                    <TextInputField name="materialId" value={materialText} labelText="Material Id" tooltip={materialText} tooltipOptions={{position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150}} disabled required />
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="selPOItemQty" labelText="Sel PO Qty" value={relatedSellerPOItem.qty} keyfilter={"pnum"} disabled required />
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="PIPunchQty" labelText="PI Punch Qty" value={eachSellerPIPunchItem.qty} keyfilter={"pnum"} disabled required />
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="currentStockQty" labelText="Avl Smart Stock Qty" value={avlSmartStockQty} keyfilter={"pnum"} disabled required />
                                                </div>
                                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                                    <TextInputField name="inputQty" labelText="DN Qty" value={eachSellerPIPunchItem.DNQty} keyfilter={"pnum"} onChange={(e) => handleSellerPIPunchItem(e, eachSellerPIPunchItem, avlSmartStockQty)} required />
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                                <div className="flex flex-column col-12 text-area">
                                    <TextAreaField name="remarks" labelText="Remarks" rows={3} onChange={handleCreateSellerDebitNoteChange} value={createSellerDebitNote.remarks} errorMessage={formErrors.remarks} required maxLength={1000} />
                                </div>
                                <div className='flex justify-content-center mt-2'>
                                    <Button label="Submit" onClick={handleSubmitClick} />
                                </div>
                            </>
                            :
                            <p>No materials with smart stock found in this pi punch!</p>
                    }
                </>

            }
        </Dialog>
    )
}

export default CreateSellerDebitNote